export enum ViewSummaryItemBlock {
  Root = 'ViewSummaryItem',
}

export enum ViewSummaryItemElement {
  Title = 'title',
}
